<div class="flex">
  <mat-checkbox
    class="!hidden"
    [checked]="checked()"
    [disabled]="disabled()"
    (change)="checkboxStateChanged.emit($event)"
    #checkbox
  />

  <button
    mat-icon-button
    type="button"
    [class]="buttonClass()"
    [disabled]="disabled()"
    (click)="onButtonClick($event, checkbox)"
  >
    @if (checkbox.checked) {
      <app-icon src="/icons/trash.svg" alt="remove" class="w-4 h-4" />
    } @else {
      <app-icon src="/icons/rotate-360.svg" alt="revert" class="w-4 h-4" />
    }
  </button>
</div>
